"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Select_exports = {};
__export(Select_exports, {
  default: () => Select_default
});
module.exports = __toCommonJS(Select_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.0898 2.75C15.8971 2.75 16.5807 3.03646 17.1406 3.60938C17.7135 4.16927 18 4.85286 18 5.66016C18 6.46745 17.7135 7.15755 17.1406 7.73047C16.5807 8.30339 15.8971 8.58984 15.0898 8.58984C14.2826 8.58984 13.5924 8.30339 13.0195 7.73047C12.4466 7.15755 12.1602 6.46745 12.1602 5.66016C12.1602 4.85286 12.4466 4.16927 13.0195 3.60938C13.5924 3.03646 14.2826 2.75 15.0898 2.75ZM15.0898 9.41016C16.1185 9.41016 16.9974 9.04557 17.7266 8.31641C18.4688 7.58724 18.8398 6.70182 18.8398 5.66016C18.8398 4.63151 18.4688 3.7526 17.7266 3.02344C16.9974 2.28125 16.1185 1.91016 15.0898 1.91016C14.0482 1.91016 13.1628 2.28125 12.4336 3.02344C11.7044 3.7526 11.3398 4.63151 11.3398 5.66016C11.3398 6.70182 11.7044 7.58724 12.4336 8.31641C13.1628 9.04557 14.0482 9.41016 15.0898 9.41016ZM5.91016 8.58984C5.10286 8.58984 4.41276 8.30339 3.83984 7.73047C3.27995 7.15755 3 6.46745 3 5.66016C3 4.85286 3.27995 4.16927 3.83984 3.60938C4.41276 3.03646 5.10286 2.75 5.91016 2.75C6.71745 2.75 7.40755 3.03646 7.98047 3.60938C8.55339 4.16927 8.83984 4.85286 8.83984 5.66016C8.83984 6.46745 8.55339 7.15755 7.98047 7.73047C7.40755 8.30339 6.71745 8.58984 5.91016 8.58984ZM5.91016 1.91016C4.88151 1.91016 3.99609 2.28125 3.25391 3.02344C2.52474 3.7526 2.16016 4.63151 2.16016 5.66016C2.16016 6.70182 2.52474 7.58724 3.25391 8.31641C3.99609 9.04557 4.88151 9.41016 5.91016 9.41016C6.95182 9.41016 7.83724 9.04557 8.56641 8.31641C9.29557 7.58724 9.66016 6.70182 9.66016 5.66016C9.66016 4.63151 9.29557 3.7526 8.56641 3.02344C7.83724 2.28125 6.95182 1.91016 5.91016 1.91016ZM15.0898 17.75C14.2826 17.75 13.5924 17.4701 13.0195 16.9102C12.4466 16.3372 12.1602 15.6471 12.1602 14.8398C12.1602 14.0326 12.4466 13.3424 13.0195 12.7695C13.5924 12.1966 14.2826 11.9102 15.0898 11.9102C15.8971 11.9102 16.5807 12.1966 17.1406 12.7695C17.7135 13.3424 18 14.0326 18 14.8398C18 15.6471 17.7135 16.3372 17.1406 16.9102C16.5807 17.4701 15.8971 17.75 15.0898 17.75ZM15.0898 11.0898C14.0482 11.0898 13.1628 11.4544 12.4336 12.1836C11.7044 12.9128 11.3398 13.7982 11.3398 14.8398C11.3398 15.8685 11.7044 16.7539 12.4336 17.4961C13.1628 18.2253 14.0482 18.5898 15.0898 18.5898C16.1185 18.5898 16.9974 18.2253 17.7266 17.4961C18.4688 16.7539 18.8398 15.8685 18.8398 14.8398C18.8398 13.7982 18.4688 12.9128 17.7266 12.1836C16.9974 11.4544 16.1185 11.0898 15.0898 11.0898ZM15.0898 12.75C14.5039 12.75 14.0091 12.9518 13.6055 13.3555C13.2018 13.7591 13 14.2539 13 14.8398C13 15.4128 13.2018 15.901 13.6055 16.3047C14.0091 16.7083 14.5039 16.9102 15.0898 16.9102C15.6628 16.9102 16.151 16.7083 16.5547 16.3047C16.9583 15.901 17.1602 15.4128 17.1602 14.8398C17.1602 14.2539 16.9583 13.7591 16.5547 13.3555C16.151 12.9518 15.6628 12.75 15.0898 12.75ZM5.91016 17.75C5.10286 17.75 4.41276 17.4701 3.83984 16.9102C3.27995 16.3372 3 15.6471 3 14.8398C3 14.0326 3.27995 13.3424 3.83984 12.7695C4.41276 12.1966 5.10286 11.9102 5.91016 11.9102C6.71745 11.9102 7.40755 12.1966 7.98047 12.7695C8.55339 13.3424 8.83984 14.0326 8.83984 14.8398C8.83984 15.6471 8.55339 16.3372 7.98047 16.9102C7.40755 17.4701 6.71745 17.75 5.91016 17.75ZM5.91016 11.0898C4.88151 11.0898 3.99609 11.4544 3.25391 12.1836C2.52474 12.9128 2.16016 13.7982 2.16016 14.8398C2.16016 15.8685 2.52474 16.7539 3.25391 17.4961C3.99609 18.2253 4.88151 18.5898 5.91016 18.5898C6.95182 18.5898 7.83724 18.2253 8.56641 17.4961C9.29557 16.7539 9.66016 15.8685 9.66016 14.8398C9.66016 13.7982 9.29557 12.9128 8.56641 12.1836C7.83724 11.4544 6.95182 11.0898 5.91016 11.0898ZM5.91016 3.58984C5.33724 3.58984 4.84896 3.79167 4.44531 4.19531C4.04167 4.59896 3.83984 5.08724 3.83984 5.66016C3.83984 6.24609 4.04167 6.74089 4.44531 7.14453C4.84896 7.54818 5.33724 7.75 5.91016 7.75C6.49609 7.75 6.99089 7.54818 7.39453 7.14453C7.79818 6.74089 8 6.24609 8 5.66016C8 5.08724 7.79818 4.59896 7.39453 4.19531C6.99089 3.79167 6.49609 3.58984 5.91016 3.58984Z",
      fill: "currentColor"
    }
  )
);
const SvgSelect = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Select_default = SvgSelect;
